import base from "./api"; // 导入接口域名列表
import axios from "./http"; // 导入http中创建的axios实例

const article = {
  articleList(token, page = 1, num = 10) {
    return axios.get("weibo/get?page=" + page + "&num=" + num, null, {
      Authorization: "Bearer " + token
    });
  },
  articlebydate(token, year, month, day, page = 1, num = 10) {
    return axios.get(
      "weibo/getdate?year=" +
        year +
        "&month=" +
        month +
        "&day=" +
        day +
        "&page=" +
        page +
        "&num=" +
        num,
      null,
      {
        Authorization: "Bearer " + token
      }
    );
  },
  searcharticle(token, content, page = 1, num = 10) {
    return axios.get(
      "weibo/search?content=" + content + "&page=" + page + "&num=" + num,
      null,
      {
        Authorization: "Bearer " + token
      }
    );
  },
  favorite(token, page = 1, num = 10) {
    return axios.get("favorite?page=" + page + "&num=" + num, null, {
      Authorization: "Bearer " + token
    });
  },
  setfavorite(token, weiboid = "4329360062185603") {
    return axios.post("favorite", weiboid, {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json"
    });
  },
  rmfavorite(token, weiboid) {
    return axios.delete("favorite/" + weiboid, null, {
      Authorization: "Bearer " + token
    });
  },
  searchfavorite(token, content, page = 1, num = 10) {
    return axios.get(
      "favorite/search?content=" + content + "&page=" + page + "&num=" + num,
      null,
      {
        Authorization: "Bearer " + token
      }
    );
  }
};

export default article;



// WEBPACK FOOTER //
// ./src/api/request.js